import React from 'react'
import {
  NO_VENDOR_STATUS_LABEL,
  NO_VENDOR_STATUS_FILTER_VALUE,
} from 'src/pages/Vendors/vendors.constants'
import { useVendorStatusFilterOptions } from 'src/pages/Vendors/vendors.hooks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

// Unlike risk tier, the options are the account's own status list rather than a
// fixed enum, so they are fetched. Values are status ids (labels are the names)
// so the request builder does not have to resolve names back to ids, and
// renaming a status does not orphan a saved filter URL.
//
// "No Status" is appended under its own sentinel value: it is the absence of a
// status id rather than one of them.
export const VendorStatusFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const statusOptions = useVendorStatusFilterOptions()

    const filterValues = [
      ...statusOptions,
      { value: NO_VENDOR_STATUS_FILTER_VALUE, label: NO_VENDOR_STATUS_LABEL },
    ]

    return (
      <FilterDropdown
        filterParam={FilterParam.VENDOR_STATUS}
        filterName={FilterName.VENDOR_STATUS}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
